var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganogramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9604_12642)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9604_12642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.90156 9.4H13.1016V10.94H13.9016V8.6H9.40156V7H8.60156V8.6H4.10156V10.94H4.90156V9.4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5H2C1.44772 11.5 1 11.9477 1 12.5V15.5C1 16.0523 1.44772 16.5 2 16.5H7C7.55228 16.5 8 16.0523 8 15.5V12.5C8 11.9477 7.55228 11.5 7 11.5Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.5H11C10.4477 11.5 10 11.9477 10 12.5V15.5C10 16.0523 10.4477 16.5 11 16.5H16C16.5523 16.5 17 16.0523 17 15.5V12.5C17 11.9477 16.5523 11.5 16 11.5Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.5H6.5C5.94772 1.5 5.5 1.94772 5.5 2.5V5.5C5.5 6.05229 5.94772 6.5 6.5 6.5H11.5C12.0523 6.5 12.5 6.05229 12.5 5.5V2.5C12.5 1.94772 12.0523 1.5 11.5 1.5Z",
    fill: "#344054"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9604_12642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9604_12642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganogramIcon);
export default __webpack_public_path__ + "static/media/organogramIcon.f034af68b4bbe8ca72f478ca47ead75c.svg";
export { ForwardRef as ReactComponent };